import React from 'react';
import ReactTimeAgo from 'react-time-ago';

import Icone from 'Component/Icone';
import Imagem from 'Component/Imagem';

interface Botoes {
    titulo: string;
    icone?: string;
    tema?: 'primary' | 'secondary' | 'light' | 'dark' | 'transparent' | 'warning' | 'success' | 'info' | 'danger';
}

export interface Props {
    titulo?: string;
    imagem?: string;
    conteudo: string;
    botoes?: Array<Botoes>;
    tema?: 'primary' | 'secondary' | 'light' | 'dark' | 'transparent' | 'warning' | 'success' | 'info' | 'danger';
    criado?: Date;
    aoFechar: () => void;
}

const Toast = ({ titulo, imagem, conteudo, tema, botoes, aoFechar, criado }: Props): React.ReactElement =>
{
    return (
        <div className={ `toast mb-3 border-0 ${tema ? `bg-${tema} text-white` : ''} show animate__animated animate__slideInRight animate__faster` }>
            { titulo && (
                <div className="toast-header">
                    { imagem && (
                        <Imagem
                            src={ imagem }
                            className="rounded me-2"
                            alt={ titulo || conteudo }
                        />
                    ) }
                    <strong className="me-auto">
                        { titulo }
                    </strong>
                    { criado && (
                        <small className="text-muted">
                            <ReactTimeAgo date={ criado } />
                        </small>
                    ) }
                    <button type="button" className="btn-close" onClick={ aoFechar }></button>
                </div>
            ) }
            <div className="d-flex align-items-start">
                <div className="toast-body">
                    { conteudo }
                    { botoes && (
                        <div className="mt-2 pt-2">
                            { botoes.map(({ titulo, tema = 'primary', icone }) => (
                                <button key={ titulo } className={ `btn btn-${tema} btn-sm me-2` }>
                                    {icone && <Icone nome={ icone } className="me-2" /> }
                                    {titulo}
                                </button>
                            )) }
                        </div>
                    ) }
                </div>
                { !titulo && (
                    <button
                        type="button"
                        className="btn-close me-2 m-auto"
                        onClick={ aoFechar }
                    ></button>
                ) }
            </div>
        </div>
    )
}

export default Toast;
